<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-10 col-md-8 col-xl-6">

      <h1 class="text-center">
        <fa-icon [icon]=faEnvelope></fa-icon> inschrijven
      </h1>

      @if(processing()) {
        <h2 class="text-center">
          <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
        </h2>
      }

      @if(alert){
      <ngb-alert [type]="alert.type" class="text-center">{{ alert.message }}</ngb-alert>
      }

      @if(!processing()) {
        <div>
          @if(!joined && !alert) {
            <div>
              @if(!pool) {
                <div class="alert alert-info text-center" role="alert">kies 1 van onderstaande opties om je in te schrijven
                </div>
                <div class="d-flex justify-content-center my-4">
                  <button type="button" class="btn btn-lg btn-primary me-4" [routerLink]="['/user/register']">
                    <fa-icon [icon]=faUserCircle></fa-icon> registreren
                  </button>
                  <button type="button" class="btn btn-xl btn-primary ms-4" [routerLink]="['/user/login']">
                    <fa-icon [icon]=faSignInAlt></fa-icon> inloggen
                  </button>
                </div>
              } @else {
                <button [routerLink]="['/']" type="button" class="btn btn-primary btn-block">
                  ga naar de home-pagina</button>         
              }          
            </div>
          }

          @if(joined && pool) {
            <div class="text-center">
              <button [routerLink]="['/pool/users', pool.getId()]" type="button" class="btn btn-primary btn-block">
                ga naar de pool
              </button>
            </div>
          }
        </div>
      }

    </div>
  </div>
</div>